import {StandardPageSize} from "@react-pdf/types";
import {Orientation} from "@react-pdf/types/page";

export const getPageOrientation = (size: StandardPageSize, orientation: Orientation) => {
  switch (size) {
    case "A4":
      return orientation;
    case "A5":
      return orientation === "portrait" ? "landscape" : "portrait";
    case "A6":
      return orientation === "portrait" ? "portrait" : "landscape";
    case "A7":
      return orientation === "portrait" ? "landscape" : "portrait";
    default:
      return "landscape";
  }
}

export const calculatePdfFontSize = (fontSize: number, pageSize: StandardPageSize) => {
  switch (pageSize) {
    case "A4":
      return fontSize;
    case "A5":
      return fontSize * 0.71;
    case "A6":
      return fontSize * 0.5;
    case "A7":
      return fontSize * 0.35;
    default:
      return fontSize;
  }
}

export const calculatePdfHeight = (height: number, pageSize: StandardPageSize) => {
  switch (pageSize) {
    case "A4":
      return height;
    case "A5":
      return height / 1.41428571;
    case "A6":
      return height / 2;
    case "A7":
      return height / 2.82857143;
    default:
      return height;
  }
}

export const calculatePdfWidth = (width: number, pageSize: StandardPageSize) => {
  switch (pageSize) {
    case "A4":
      return width;
    case "A5":
      return width / 1.41414141;
    case "A6":
      return width / 2;
    case "A7":
      return width / 2.82828283;
    default:
      return width;
  }
}

export const labelsNumberOnPage = (size: StandardPageSize): number => {
  switch (size) {
    case "A4":
      return 1;
    case "A5":
      return 2;
    case "A6":
      return 4;
    case "A7":
      return 8;
    default:
      return 1;
  }
}

const rowsNumberOnPage = (size: StandardPageSize, orientation: Orientation): number => {
  switch (orientation) {
    case "portrait":
      return rowsNumberPortraitOnPage(size);
    case "landscape":
      return rowsNumberLandscapeOnPage(size);
    default:
      return 1;
  }
}

const rowsNumberPortraitOnPage = (size: StandardPageSize): number => {
  switch (size) {
    case "A4":
      return 1;
    case "A5":
      return 1;
    case "A6":
      return 2;
    case "A7":
      return 2;
    default:
      return 1;
  }
}

const rowsNumberLandscapeOnPage = (size: StandardPageSize): number => {
  switch (size) {
    case "A4":
      return 1;
    case "A5":
      return 2;
    case "A6":
      return 2;
    case "A7":
      return 4;
    default:
      return 1;
  }
}

export const getCuttingBorders = (size: StandardPageSize, orientation: Orientation, index: number): object => {
  const labelsNumber = labelsNumberOnPage(size);

  const rowsNumber = rowsNumberOnPage(size, orientation);
  const columnsNumber = Math.ceil(labelsNumber / rowsNumber);

  const currentRow = Math.ceil((index + 1) / columnsNumber);
  const isLastRow = currentRow >= rowsNumber;

  const currentColumn = (index % columnsNumber) + 1;
  const isLastColumn = currentColumn >= columnsNumber;

  const borderStyle = '1px dashed black';

  let borders = {
    borderRight: '0',
    borderBottom: '0',
  }

  if (!isLastRow) {
    borders.borderBottom = borderStyle;
  }

  if (!isLastColumn) {
    borders.borderRight = borderStyle;
  }

  return borders;
}
